import React, { useState, useEffect } from 'react';
import { Drawer, Button } from 'antd';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import dayjs, { Dayjs } from 'dayjs';
import styles from './DrawerModalMobile.module.css';

interface MonthlyPickerModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (date: Dayjs) => void;
  selectedDate?: Dayjs;
  title?: string;
}

const MONTHS = [
  'Tháng 1', 'Tháng 2', 'Tháng 3', 'Tháng 4', 'Tháng 5', 'Tháng 6',
  'Tháng 7', 'Tháng 8', 'Tháng 9', 'Tháng 10', 'Tháng 11', 'Tháng 12'
];

export const MonthlyPickerModal: React.FC<MonthlyPickerModalProps> = ({
  isOpen,
  onClose,
  onSelect,
  selectedDate,
  title = 'Chọn tháng'
}) => {
  const [currentYear, setCurrentYear] = useState<number>(selectedDate ? selectedDate.year() : dayjs().year());
  const [hoveredMonth, setHoveredMonth] = useState<number | null>(null);

  useEffect(() => {
    if (selectedDate) {
      setCurrentYear(selectedDate.year());
    }
  }, [selectedDate]);

  const handleMonthClick = (monthIndex: number) => {
    const selectedMonth = dayjs().year(currentYear).month(monthIndex);
    onSelect(selectedMonth);
    onClose();
  };

  const handlePrevYear = () => {
    setCurrentYear(currentYear - 1);
  };

  const handleNextYear = () => {
    setCurrentYear(currentYear + 1);
  };

  const isCurrentMonth = (monthIndex: number) => {
    const currentDate = dayjs();
    return currentDate.year() === currentYear && currentDate.month() === monthIndex;
  };

  const isSelected = (monthIndex: number) => {
    return selectedDate && selectedDate.year() === currentYear && selectedDate.month() === monthIndex;
  };

  const getMonthGrid = () => {
    const months = [];
    for (let i = 0; i < 12; i++) {
      months.push(i);
    }
    return months;
  };

  const months = getMonthGrid();

  return (
    <Drawer
      open={isOpen}
      onClose={onClose}
      placement="bottom"
      height="auto"
      className={styles.monthlyPickerDrawer}
      contentWrapperStyle={{
        borderRadius: '16px 16px 0 0',
        overflow: 'hidden'
      }}
      maskStyle={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)'
      }}
      bodyStyle={{
        padding: 0,
        borderRadius: '16px 16px 0 0',
        overflow: 'hidden'
      }}
      headerStyle={{
        display: 'none'
      }}
      closeIcon={null}
    >
      <div className={styles.monthlyPickerContainer}>
        {/* Header */}
        <div className={styles.monthlyPickerHeader}>
          <div className={styles.monthlyPickerTitle}>{title}</div>
        </div>

        {/* Year Navigation */}
        <div className={styles.monthlyPickerNavigation}>
          <Button
            type="text"
            icon={<LeftOutlined />}
            onClick={handlePrevYear}
            className={styles.monthlyPickerNavButton}
          />
          <div className={styles.monthlyPickerYear}>
            {currentYear}
          </div>
          <Button
            type="text"
            icon={<RightOutlined />}
            onClick={handleNextYear}
            className={styles.monthlyPickerNavButton}
          />
        </div>

        {/* Months Grid */}
        <div className={styles.monthlyPickerGrid}>
          {months.map((monthIndex) => (
            <div
              key={monthIndex}
              className={`${styles.monthlyPickerMonth} ${
                isCurrentMonth(monthIndex) ? styles.monthlyPickerCurrent : ''
              } ${isSelected(monthIndex) ? styles.monthlyPickerSelected : ''} ${
                hoveredMonth === monthIndex ? styles.monthlyPickerHovered : ''
              }`}
              onClick={() => handleMonthClick(monthIndex)}
              onMouseEnter={() => setHoveredMonth(monthIndex)}
              onMouseLeave={() => setHoveredMonth(null)}
            >
              {MONTHS[monthIndex]}
            </div>
          ))}
        </div>
      </div>
    </Drawer>
  );
};
